/**
 * Explicit active-state helpers for ArchiveContextNav.
 * React Router's NavLink does not treat ?tab= / ?view= the way our tree & person UIs need.
 */
export function getArchiveNavActives(location, { treeId, personId, variant, treeLinkBase } = {}) {
  const pathname = location.pathname || '';
  const sp = new URLSearchParams(location.search || '');
  const tab = sp.get('tab');
  const view = sp.get('view');
  const treeRootPretty = (treeLinkBase || '').split('?')[0] || '';
  const treeRootUuid = `/tree/${treeId}`;
  const treeRoot = treeRootPretty || treeRootUuid;
  const membersPath = `${treeRoot}/members`;
  const membersPathUuid = `${treeRootUuid}/members`;
  const onTreeRoot = pathname === treeRoot || pathname === treeRootUuid;
  const onMembers = pathname === membersPath || pathname === membersPathUuid;
  const personPath = personId ? `/person/${personId}` : '';
  const onPerson = Boolean(personId && pathname === personPath);

  return {
    dashboard: pathname === '/dashboard',
    settings: pathname === '/settings' || pathname.startsWith('/settings/'),
    treeChart: onTreeRoot && !onMembers && tab === 'chart',
    treePeople: onTreeRoot && !onMembers && (tab === 'grid' || tab === null || tab === ''),
    treeTimeline: onTreeRoot && !onMembers && tab === 'timeline',
    treeSettings: onTreeRoot && !onMembers && tab === 'settings',
    treeReadiness: onTreeRoot && !onMembers && tab === 'readiness',
    treeMembers: onMembers,
    personStories: onPerson && view === 'stories',
    personDocuments: onPerson && view === 'documents',
    personShared: onPerson && view === 'shared',
    personFamily: onPerson && view === 'family',
    memorials: pathname.startsWith('/memorials'),
    /** Bottom bar: Tree jumps to chart tab. */
    mobileTree: onTreeRoot && !onMembers && tab === 'chart',
    mobilePeople: onTreeRoot && !onMembers && (tab === 'grid' || tab === null || tab === ''),
    mobileStories: variant === 'person' && onPerson && view === 'stories',
  };
}
